import { isBusy, stateLabel, type SheetState } from '../model';

export function StateBadge({ state }: { state: SheetState }) {
  const tone =
    state === 'approved' || state === 'printed' ? 'good'
      : state === 'refused' || state === 'error' ? 'bad'
        : state === 'needs_review' ? 'review'
          : isBusy(state) ? 'busy' : 'idle';
  return (
    <span className={`badge badge-${tone}`}>
      {isBusy(state) && <span className="spinner" aria-hidden />}
      {stateLabel(state)}
    </span>
  );
}
